import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  message: null,
  error: null,
  data: [],
};

const getMotorYearSlice = createSlice({
  name: "getMotorYear",
  initialState,
  reducers: {
    getMotorYearStart(state, payload) {
      state.loading = true;
      state.error = null;
      state.message = null;
    },

    getMotorYearSuccess(state, action) {
      state.loading = false;
      const flattenedArray = []?.concat(...action?.payload);
      state.data = flattenedArray;
      state.message = action.payload.message;
    },
    getMotorYearFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.message = null;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearMessage: (state) => {
      state.message = null;
    },
  },
});

export const {
  getMotorYearStart,
  getMotorYearSuccess,
  getMotorYearFailure,
  clearError,
  clearMessage,
} = getMotorYearSlice.actions;

export default getMotorYearSlice.reducer;
